/**
 * Можно ли открыть разовый анонс ежедневной «Битвы с AI Claude Opus» прямо
 * сейчас (см. AiMatchNewsModal).
 *
 * Приоритет — как у новости о рейтинговых обличиях, сразу после нее: анонс
 * ждет, пока свободна очередь всех остальных модалок меню
 * (isMenuModalQueueBusy — в нее входит и положенная новость об обличиях) и
 * пока закрыта сама новость, и не ложится поверх того, что открыто игроком
 * или App (вход для гостя, установка приложения, вступительная колода).
 *
 * Пока лобби дня ждет игроков (isAiPromoJoinable), анонс молчит: в это время
 * меню зовет в матч ежедневным приглашением (AiMatchPromoModal) — оно
 * полезнее рассказа «заходи в 21:00», и две модалки об одном событии подряд
 * ни к чему. Анонс при этом не отмечается и покажется в следующий раз вне
 * окна набора. Пока ответа о лобби дня нет (isAiPromoChecked), не знаем, идет
 * ли набор, — анонс тоже ждет.
 *
 * @param {Object} params
 * @param {boolean} params.isQueued - анонс положен и не заглушен на этот заход
 * @param {boolean} params.isOpen - уже открыт
 * @param {boolean} params.isMenuModalQueueBusy
 * @param {boolean} [params.isRankSkinsNewsOpen]
 * @param {boolean} [params.isAiMatchPromoOpen]
 * @param {boolean} [params.isAiPromoJoinable] - лобби дня сейчас набирает игроков
 * @param {boolean} [params.isAiPromoChecked] - ответ о лобби дня уже получен
 * @param {string|null} [params.loginRequiredReason]
 * @param {boolean} [params.isAppInstallPromoOpen]
 * @param {boolean} [params.isIntroSlidesVisible]
 * @returns {boolean}
 */
export const checkIfAiMatchNewsOpenable = ({
  isQueued,
  isOpen,
  isMenuModalQueueBusy,
  isRankSkinsNewsOpen,
  isAiMatchPromoOpen,
  isAiPromoJoinable,
  isAiPromoChecked,
  loginRequiredReason,
  isAppInstallPromoOpen,
  isIntroSlidesVisible,
}) => Boolean(isQueued)
  && !isOpen
  && !isMenuModalQueueBusy
  && !isRankSkinsNewsOpen
  && !isAiMatchPromoOpen
  && !isAiPromoJoinable
  && Boolean(isAiPromoChecked)
  && !loginRequiredReason
  && !isAppInstallPromoOpen
  && !isIntroSlidesVisible;
